import React from 'react'
import { useLocation } from 'react-router'

export function useScrollRestoration() {
  const location = useLocation()

  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [location])
}
